// extracted by mini-css-extract-plugin
export var text = "_9p-0";